import { render, staticRenderFns } from "./branchButtonGroup.vue?vue&type=template&id=01871233&scoped=true&"
import script from "./branchButtonGroup.vue?vue&type=script&lang=js&"
export * from "./branchButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./branchButtonGroup.vue?vue&type=style&index=0&id=01871233&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01871233",
  null
  
)

export default component.exports